export default ({ sendBoxValue }) => sendBoxValue;
